var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1),_c('BrSnackbar',{attrs:{"snackbar":_vm.snackbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }